import store from '@/store/store';

export class HospitalApi {
    constructor(client) {
        this.client = client;
    }

    async list() {
        const data = await this.client.get('/api/Pages/start/' + store.getters['session/get'].nameID, {
            anonymous: true
        });

        for (var i = 0; i < data.sites.length; i++) {
            // if locationName is empty use siteName
            if (data.sites[i].locationName == '') {
                data.sites[i].locationName = data.sites[i].siteName;
            }

            // remove 'null' sites from contact sites
            for (var j = 0; j < data.sites[i].contacts.length; j++) {
                for (var z = 0; z < data.sites[i].contacts[j].sites.length; z++) {
                    if (data.sites[i].contacts[j].sites[z] == null) {
                        data.sites[i].contacts[j].sites.splice(z, 1);
                    }else{
                        if(data.sites[i].contacts[j].sites[z].locationName == ''){
                            data.sites[i].contacts[j].sites[z].locationName = data.sites[i].contacts[j].sites[z].siteName;
                        }
                    }
                }
            }

            data.sites[i].contacts.sort(function(x,y){ 
                return x.id == store.getters['session/get'].nameID? -1 : y.id == store.getters['session/get'].nameID ? 1 : 0; 
            });
        }

        return data;
    }

    async getContact(id) {
        const contact = await this.client.get('/api/Contacts/' + id, {
            anonymous: true
        });

        return contact;
    }

    async changeHospitalName(data) {
        const response = await this.client.put('/api/Sites/' + data.id, {
            locationName: data.name
        });
        return response;
    }

    async changeContactDetails(data) {
        var id = store.getters['session/get'].nameID;
        await this.client.put('/api/Contacts/' + id, data);
    }
}